
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.75 5C5.75 5 6.375 16 3 16h14.25c-4.125 0-3.5-11-7.5-11z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M16.473 8.667c-2.785 0-2.35 7.333-5.223 7.333H21c-2.09 0-1.741-7.333-4.527-7.333z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M6 15.75h4.5m-4.5 0a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm4.5 0a1.5 1.5 0 003 0m-3 0a1.5 1.5 0 013 0m0 0H18m0 0a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0z","stroke":"#4A4A4A","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    